import React, { useState, useRef, useEffect } from 'react';
import './Artventure.css';

import productImage1 from '../images/art-pic1.jpg';
import productImage2 from '../images/art-pic1.jpg';
import productImage3 from '../images/art-pic1.jpg';
import leftArrow from '../images/arrowl.png'; // Your custom left arrow image
import rightArrow from '../images/arrowr.png'; // Your custom right arrow image
import bt_playstone from '../images/p-d-n.png';
import bt_applesotre from '../images/ap-d-n.png';

const productImages = [productImage1, productImage2, productImage3];


const DigitalConfirmArtVentureNFT = () => {
  const [imageIndex, setImageIndex] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);
  const [showToggle, setShowToggle] = useState(false);
  const fullTextRef = useRef<HTMLParagraphElement>(null);

  const handleNextImage = () => {
    setImageIndex((prevIndex) => (prevIndex + 1) % productImages.length);
  };

  const handlePrevImage = () => {
    setImageIndex((prevIndex) => (prevIndex - 1 + productImages.length) % productImages.length);
  };

  const descriptionText = `เราเชื่อมโยงโลกแห่งศิลปะที่ซึ่งความจริงและเสมือนมาบรรจบกัน

ดินแดนแห่งศิลปะที่เชื่อมโยงสุนทรียภาพระหว่างโลกแห่งความจริงและโลกเสมือนเสมือนเป็นโอเอซิสแห่งศิลปะและให้ศิลปินทั้งสองได้มาพบปะ สร้างสรรค์ แลกเปลี่ยน และแสดงความคิดเกี่ยวกับศิลปะ

พวกเราทีม ArtVenture จึงเป็นผู้สนับสนุนผลงานชิ้นเอกเหล่านี้ให้เป็นที่รู้จักไปทั่วโลก ผลงานศิลปะของศิลปินที่ได้รับการคัดเลือกจะจัดแสดงในนิทรรศการในสถานที่และตลาดออนไลน์ ทั้งบนเว็บไซต์ทางการของเราและตลาดศิลปะ NFT ออนไลน์ชั้นนำ นอกจากนี้ยังใช้สำหรับตลาดศิลปะ NFT ระดับมืออาชีพสำหรับงานแสดงศิลปะนานาชาติ
`;
  

  const shortDescription = descriptionText.slice(0, 120) + '...';

    // ✅ ตรวจสอบว่าข้อความเกิน 10 บรรทัดหรือไม่
    useEffect(() => {
      const element = fullTextRef.current;
    
      if (element) {
        requestAnimationFrame(() => {
          const lineHeight = parseFloat(getComputedStyle(element).lineHeight || '10');
          const lineCount = element.scrollHeight / lineHeight;
          setShowToggle(lineCount > 5);
        });
      }
    }, []);
    

  return (
    <div className="container">
      
      <div className='artven'>
      
      <br/>
      <h2>ArtVentureNFT</h2>

      <div className="image-container">
        <button className="image-nav left" onClick={handlePrevImage}>
          <img src={leftArrow} alt="Previous" />
        </button>
        <img src={productImages[imageIndex]} alt="Product" />
        <button className="image-nav right" onClick={handleNextImage}>
          <img src={rightArrow} alt="Next" />
        </button>
      </div>
      {/* ✅ Description section with toggle */}
      <div className="description">
        <h2>Description</h2>
        <div
          ref={fullTextRef}
          className={isExpanded ? 'expanded' : 'clamped'}
        >
          {descriptionText}
        </div>

        {showToggle && (
          <button onClick={() => setIsExpanded(!isExpanded)} style={{ marginTop: '8px' }}>
            {isExpanded ? 'ย่อข้อความ ▲' : 'อ่านเพิ่มเติม ▼'}
          </button>
        )}
      </div>

      <div className="details">
        <h2>Details</h2>
        <p><strong>Brand:</strong> ArtVentureNFT</p>
        <p><strong>Edition:</strong> 1/1</p>
        <p><strong>Country:</strong> Thailand</p>
        <p><strong>Size:</strong> 70x70</p>
        <p><strong>Variental:</strong> ArtVentureNFT</p>
        <p><strong>Owner:</strong> ArtVentureNFT</p>
      </div>
      <div className="bottom"> 
        <p className='px'>Cool AR experiences await you!</p>
        <p>Download the app now!</p>
        <div className="store-links">
          <a href="https://play.google.com/store/search?q=artventure&c=apps&hl=th-TH" target="_blank" rel="noopener noreferrer">
            <img src={bt_playstone} alt="Play Store" />
          </a>
          <a href="https://apps.apple.com/th/app/artventurenft/id6472034909?l=th" target="_blank" rel="noopener noreferrer">
            <img src={bt_applesotre} alt="Apple Store" />
          </a>
        </div>
      </div>
      </div>
      <div className="footer">
        <p>copy right 2024 ArtventureNFT Thailand</p>
      </div>
    </div>
  );
};

export default DigitalConfirmArtVentureNFT;
